import Modal from '../helpers/Modal';
import Params from '../helpers/Params';
import SubmissionForm from '../helpers/SubmissionForm';
export default class MembershipBlock {
    constructor(root) {
        this.root = root;

        this.modal_root = document.querySelector('.js-membership-sharing-modal');
        this.form_root = this.modal_root?.querySelector('.js-membership-sharing-modal-form');
        this.add_buttons = this.root.querySelectorAll('.js-membership-block-add-button');
        this.params = new Params();

        this.add_buttons.forEach((add_button) => {
            add_button.addEventListener('click', (event) => {
                event.preventDefault();

                this.addMembership(event.target.dataset.id);
            });
        });

        this.sharing_buttons = document.querySelectorAll('.js-membership-block-share-button');

        this.sharing_buttons.forEach((share_button) => {
            share_button.addEventListener('click', (event) => {
                event.preventDefault();

                if(share_button.dataset.action == 'remove') {
                    this.updateSharing({
                        action: 'membership_sharing',
                        sharing_action: 'remove'
                    });
                } else if(share_button.dataset.action == 'decline') {
                    this.updateSharing({
                        action: 'membership_sharing',
                        sharing_action: 'decline',
                        user_uuid: share_button.dataset.userUuid
                    });
                } else if(share_button.dataset.action == 'accept') {
                    this.updateSharing({
                        action: 'membership_sharing',
                        sharing_action: 'accept',
                        user_uuid: share_button.dataset.userUuid
                    });
                } else if(share_button.dataset.action == 'delete') {
                    this.updateSharing({
                        action: 'membership_sharing',
                        sharing_action: 'delete',
                        user_uuid: share_button.dataset.userUuid
                    }, null, (data) => {
                        this.params.set('mdl', 'membership-sharing');
                        this.params.updateUrl();
                        location.reload();
                    });
                }
            });
        });

        if(this.form_root) {
            this.form = new SubmissionForm(this.form_root, 'membership-sharing-modal-form', () => {
                this.form.enable(this.form.submit);
                this.form.hide(this.form.sending_message);

                let email_field = this.form_root.querySelector('[name="member-email"]');

                this.updateSharing({
                    action: 'membership_sharing',
                    sharing_action: 'share',
                    user_email: email_field.value
                }, (data) => {
                    email_field.classList.add('--error');
                    this.form.custom_error_message.innerText = data.error_description;
                    this.form.show(this.form.custom_error_message);
                }, (data) => {
                    this.params.set('mdl', 'membership-sharing');
                    this.params.updateUrl();
                    location.reload();
                });
            });
        }

        if(this.modal_root) {
            this.sharing_add_button = this.modal_root.querySelector('.js-membership-sharing-modal-add-button');
            this.sharing_save_button = this.modal_root.querySelector('.js-membership-sharing-modal-save-button');

            if(this.sharing_add_button) {
                this.sharing_add_button.addEventListener('click', (event) => {
                    event.preventDefault();
    
                    let email_field = this.form_root.querySelector('[name="member-email"]');
    
                    email_field.focus();
    
                    this.sharing_add_button.parentElement.classList.add('--hidden');
                    this.form_root.parentElement.classList.add('--active');
                });
            }

            this.modal = new Modal(this.modal_root, (dataset) => {
                
            },
            () => {
                this.sharing_add_button?.parentElement.classList.remove('--hidden');
                this.form_root?.parentElement.classList.remove('--active');
                this.form?.resetForm();

                if(this.params.get('mdl') == 'membership-sharing') {
                    this.params.remove('mdl');
                }
            });
        }
    }

    addMembership(id) {
        if(!window.theme.cart.hasItem(id)) {
            window.theme.cart.add(id);
        }
    }

    updateSharing(post_data, error_callback = null, success_callback = null) {
        jQuery.ajax({
            type: 'POST',
            dataType: 'json',
            url: window.theme.variables.ajax_url,
            data: post_data,
            success: (data) => {
                if(data.status == 'error') {
                    if(error_callback) {
                        error_callback(data);
                    }
                } else if(success_callback) {
                    success_callback(data);
                } else {
                    location.reload();
                }
            }
        });
    }
}
